// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
export var CancelButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n    padding: 0 4rem;\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n    padding: 0 4rem;\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
});
export var NextButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n    padding: 0 4rem;\n\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n"], ["\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n    padding: 0 4rem;\n\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
});
export var StyledTitle = styled("div")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: rgba(0, 0, 0, 0.87);\n    font-size: 24px;\n    font-family: Roboto;\n    font-weight: 700;\n    line-height: 32.02px;\n    word-wrap: break-word;\n"], ["\n    color: rgba(0, 0, 0, 0.87);\n    font-size: 24px;\n    font-family: Roboto;\n    font-weight: 700;\n    line-height: 32.02px;\n    word-wrap: break-word;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
